export default __webpack_public_path__ + "static/media/OEFFNUNGSZEITENBUCH.710cc6f2.png";